import { render } from "./AuthCognitoRedirect.vue?vue&type=template&id=60c4cd9f"
import script from "./AuthCognitoRedirect.vue?vue&type=script&lang=js"
export * from "./AuthCognitoRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__